<template>
  <div class="import">
    <div class="customer">
      <div class="title">{{$t('label.importKH')}}</div>

      <div class="row">
        <div class="col-md-12">
          <div class="px-3 pt-2">
            <label class="font-bold">Loại dữ liệu</label>
            <b-form-select
              v-model="customerType"
              :options="customerTypeOptions">
            </b-form-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="px-3 pt-2">
            <label class="font-bold">File Excel</label>
            <b-form-file
              ref="fileUpload"
              id="upload"
              accept=".xlsx"
              :disabled="!customerType"
              @change="uploadFile($event.target.files)">
            </b-form-file>

            <!-- File mẫu -->
            <label class="mt-2 d-block">
              File mẫu:
              <a
                v-if="customerType === 'new'"
                href="/downloads/new_customers.xlsx"
                download>
                new_customers.xlsx
              </a>

              <a
                v-else-if="customerType === 'ordered'"
                href="/downloads/ordered _customer.xlsx"
                download>
                ordered _customer.xlsx
              </a>
            </label>
          </div>
        </div>
      </div>
    </div>
<!--
    <b-modal v-model="openErrorModal" hide-footer>
      <template #modal-header>
        <h5 class="mb-0">Chi tiết import</h5>
      </template>

      <div v-if="errors.length">
        <p
          v-for="(error, index) in errors"
          :key="index"
          class="mb-1">
          {{ error }}
        </p>
      </div>

      <div v-else>
        <p>Không có lỗi chi tiết.</p>
      </div>

      <div class="text-right mt-3">
        <b-button size="sm" variant="danger" @click="closeModal">
          Đóng
        </b-button>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      customerType: '',

      customerTypeOptions: [
        { value: '', text: 'Chọn loại dữ liệu' },
        { value: 'new', text: 'Khách hàng mới' },
        { value: 'ordered', text: 'Khách hàng đã tạo đơn' }
      ],

      errors: [],
      openErrorModal: false
    }
  },

  methods: {
    async uploadFile(files) {
      if (!files || !files.length) return

      if (!this.customerType) {
        this.$bvToast.toast('Vui lòng chọn loại khách hàng', {
          title: 'Lỗi',
          toaster: 'b-toaster-top-right',
          variant: 'danger',
          solid: true
        })
        return
      }

      const formData = new FormData()
      formData.append('file', files[0])
      formData.append('customerType', this.customerType)

      this.errors = []
      this.openErrorModal = false

      try {
        this.$isLoading(true)

        const res = await apiClient.post(
          '/api/v1/admin/upload',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 0
          }
        )

        const {
          importedCount = 0,
          duplicatedCount = 0,
          totalRows = 0,
          duplicatedQrpayboxUserIds = []
        } = res.data || {}

        if (importedCount > 0 && duplicatedCount === 0) {
          this.$bvToast.toast(
            `Import thành công ${importedCount}/${totalRows} khách hàng.`,
            {
              title: 'Thành công',
              toaster: 'b-toaster-top-right',
              variant: 'primary',
              solid: true
            }
          )
          return
        }

        if (importedCount > 0 && duplicatedCount > 0) {
          this.$bvToast.toast(
            `Import thành công ${importedCount}/${totalRows} khách hàng.
             ${duplicatedCount} khách hàng bị trùng và đã được bỏ qua.`,
            {
              title: 'Hoàn thành một phần',
              toaster: 'b-toaster-top-right',
              variant: 'warning',
              solid: true
            }
          )

          this.errors = duplicatedQrpayboxUserIds.map(
            id => `Khách hàng có ID ${id} đã tồn tại trong hệ thống`
          )
          this.openErrorModal = true
          return
        }

        if (importedCount === 0 && duplicatedCount > 0) {
          this.$bvToast.toast(
            `Import thất bại. ${duplicatedCount}/${totalRows} khách hàng đã tồn tại.`,
            {
              title: 'Import không thành công',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
              solid: true
            }
          )

          this.errors = duplicatedQrpayboxUserIds.map(
            id => `Khách hàng có ID ${id} đã tồn tại trong hệ thống`
          )
          this.openErrorModal = true
        }
      } catch (error) {
        const data = error.response?.data

        if (data?.errors?._data?.length) {
          this.errors = data.errors._data.map(
            e => `Dòng ${e[0] + 2}: ${e[1]}`
          )
          this.openErrorModal = true
          return
        }

        this.$bvToast.toast(
          'File không đúng định dạng hoặc dữ liệu không hợp lệ.' || data?.message,
          {
            title: 'Lỗi',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
            solid: true
          }
        )
      } finally {
        this.$refs.fileUpload?.reset()
        this.$isLoading(false)
      }
    },

    closeModal() {
      this.openErrorModal = false
    }
  }
}
</script>

<style scoped lang="stylus">
.import {
  .customer {
    background: #d3d3d3;

    .title {
      background: #e04c4c;
      color: #fff;
      padding: 1rem;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
    }
  }
}
</style>
